/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetCompanyDto } from './GetCompanyDto';
import {
    GetCompanyDtoFromJSON,
    GetCompanyDtoFromJSONTyped,
    GetCompanyDtoToJSON,
} from './GetCompanyDto';
import type { GetEmployeeDto } from './GetEmployeeDto';
import {
    GetEmployeeDtoFromJSON,
    GetEmployeeDtoFromJSONTyped,
    GetEmployeeDtoToJSON,
} from './GetEmployeeDto';

/**
 * 
 * @export
 * @interface GetEmailDto
 */
export interface GetEmailDto {
    /**
     * 
     * @type {string}
     * @memberof GetEmailDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetEmailDto
     */
    sentMessageInfo: string;
    /**
     * 
     * @type {string}
     * @memberof GetEmailDto
     */
    status: GetEmailDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEmailDto
     */
    sentTo: string;
    /**
     * 
     * @type {string}
     * @memberof GetEmailDto
     */
    sentCc: string;
    /**
     * 
     * @type {string}
     * @memberof GetEmailDto
     */
    sentBcc: string;
    /**
     * 
     * @type {string}
     * @memberof GetEmailDto
     */
    sentFrom: string;
    /**
     * 
     * @type {Date}
     * @memberof GetEmailDto
     */
    sendDate: Date;
    /**
     * 
     * @type {string}
     * @memberof GetEmailDto
     */
    subject: string;
    /**
     * 
     * @type {string}
     * @memberof GetEmailDto
     */
    message: string;
    /**
     * 
     * @type {GetCompanyDto}
     * @memberof GetEmailDto
     */
    company: GetCompanyDto;
    /**
     * 
     * @type {GetEmployeeDto}
     * @memberof GetEmailDto
     */
    owner: GetEmployeeDto;
    /**
     * 
     * @type {string}
     * @memberof GetEmailDto
     */
    emailType: GetEmailDtoEmailTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEmailDto
     */
    parentEmailId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetEmailDto
     */
    hasResends?: boolean;
}


/**
 * @export
 */
export const GetEmailDtoStatusEnum = {
    NotSent: 'NotSent',
    Sent: 'Sent',
    Error: 'Error'
} as const;
export type GetEmailDtoStatusEnum = typeof GetEmailDtoStatusEnum[keyof typeof GetEmailDtoStatusEnum];

/**
 * @export
 */
export const GetEmailDtoEmailTypeEnum = {
    SalesInvoiceToContractor: 'SalesInvoiceToContractor',
    SalesInvoiceDuplicateToContractor: 'SalesInvoiceDuplicateToContractor',
    SurveyToClient: 'SurveyToClient',
    ExcelImport: 'ExcelImport',
    Applications: 'Applications',
    PositionAppForeign: 'PositionAppForeign',
    ApplicationExecutions: 'ApplicationExecutions',
    Orders: 'Orders',
    OrdersRemind: 'OrdersRemind',
    OrderExecutions: 'OrderExecutions',
    OrderExecutionsRemind: 'OrderExecutionsRemind',
    UnblockEstimateByMonth: 'UnblockEstimateByMonth',
    PurchaserCreatedInOrder: 'PurchaserCreatedInOrder',
    PurchaserEditedInOrder: 'PurchaserEditedInOrder',
    TooManyPurchasersInOrder: 'TooManyPurchasersInOrder',
    ProjectDelayed: 'ProjectDelayed',
    ProjectToCancel: 'ProjectToCancel',
    ProjectDateChange: 'ProjectDateChange',
    PurchaseDeficiencies: 'PurchaseDeficiencies',
    SalesInvoicing: 'SalesInvoicing',
    SpecialInvoicing: 'SpecialInvoicing',
    ContractImportError: 'ContractImportError',
    ContractsWaitingToSign: 'ContractsWaitingToSign',
    SignedContracts: 'SignedContracts',
    ContractSignedNotSent: 'ContractSignedNotSent',
    ContractUnsigned: 'ContractUnsigned',
    CyclicJobError: 'CyclicJobError',
    FvzTeamReminder: 'FVZTeamReminder',
    NoPurchaserInOrder: 'NoPurchaserInOrder',
    MirrorProject: 'MirrorProject',
    MirrorProjectError: 'MirrorProjectError'
} as const;
export type GetEmailDtoEmailTypeEnum = typeof GetEmailDtoEmailTypeEnum[keyof typeof GetEmailDtoEmailTypeEnum];


/**
 * Check if a given object implements the GetEmailDto interface.
 */
export function instanceOfGetEmailDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "sentMessageInfo" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "sentTo" in value;
    isInstance = isInstance && "sentCc" in value;
    isInstance = isInstance && "sentBcc" in value;
    isInstance = isInstance && "sentFrom" in value;
    isInstance = isInstance && "sendDate" in value;
    isInstance = isInstance && "subject" in value;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "company" in value;
    isInstance = isInstance && "owner" in value;
    isInstance = isInstance && "emailType" in value;

    return isInstance;
}

export function GetEmailDtoFromJSON(json: any): GetEmailDto {
    return GetEmailDtoFromJSONTyped(json, false);
}

export function GetEmailDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetEmailDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'sentMessageInfo': json['sentMessageInfo'],
        'status': json['status'],
        'sentTo': json['sentTo'],
        'sentCc': json['sentCc'],
        'sentBcc': json['sentBcc'],
        'sentFrom': json['sentFrom'],
        'sendDate': (new Date(json['sendDate'])),
        'subject': json['subject'],
        'message': json['message'],
        'company': GetCompanyDtoFromJSON(json['company']),
        'owner': GetEmployeeDtoFromJSON(json['owner']),
        'emailType': json['emailType'],
        'parentEmailId': !exists(json, 'parentEmailId') ? undefined : json['parentEmailId'],
        'hasResends': !exists(json, 'hasResends') ? undefined : json['hasResends'],
    };
}

export function GetEmailDtoToJSON(value?: GetEmailDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'sentMessageInfo': value.sentMessageInfo,
        'status': value.status,
        'sentTo': value.sentTo,
        'sentCc': value.sentCc,
        'sentBcc': value.sentBcc,
        'sentFrom': value.sentFrom,
        'sendDate': (value.sendDate.toISOString()),
        'subject': value.subject,
        'message': value.message,
        'company': GetCompanyDtoToJSON(value.company),
        'owner': GetEmployeeDtoToJSON(value.owner),
        'emailType': value.emailType,
        'parentEmailId': value.parentEmailId,
        'hasResends': value.hasResends,
    };
}

